export default __webpack_public_path__ + "static/flag-fi-34713e6a38cdbc1cb511d85eac592f6c.svg";